import { Facebook, Instagram } from "lucide-react";
import { BsWhatsapp } from "react-icons/bs";
import useShareButton from "../hooks/useShareButton";

function ShareButton({ url, title }) {
  const { open, setOpen, shareLinks, handleShare } =
    useShareButton({ url, title });

  return (
    <>
      {/* Mobile Share */}
      <div className="share_btn mobshare" onClick={handleShare}>
        <span>
            {/* <Share2 size={14} /> */}
             <i className="bi bi-share"></i>
          </span>

      </div>

      {/* Desktop Share Button */}
      {!open && (
        <div
          className="share_btn webshare"
          onMouseEnter={() => setOpen(true)}
        >
         <span style={{ fontSize:"15px"}}>
            {/* <Share2 size={14} /> */}
            <i className="bi bi-share"></i>&nbsp;
            SHARE
          </span>

        </div>
      )}

      {/* Share Dropdown */}
      {open && (
        <div className="relative">
          <div
            className="absolute left-1/2 -translate-x-1/2  shadow-lg rounded-xl p-3 mt-2 flex gap-3 z-999999  track_bound share-button-box"
            onMouseLeave={() => setOpen(false)}
          >
            <a href={shareLinks.whatsapp} target="_blank" rel="noreferrer" style={{ marginRight:"8px", color:"#242323"}}>
              <BsWhatsapp size={16} className="text-green-600" />
            </a>

            <a href={shareLinks.facebook} target="_blank" rel="noreferrer" style={{ marginRight:"8px", color:"#242323"}}>
              <Facebook size={16} className="text-blue-600" />
            </a>

            <a href={shareLinks.instagram} target="_blank" rel="noreferrer" style={{color:"#242323"}}>
              <Instagram size={16} className="text-pink-500" />
            </a>
          </div>
        </div>
      )}
    </>
  );
}

export default ShareButton;